import { createContext, useContext } from 'react';
import { EnterToSubmitMode } from './useEnterToSubmit';

export type EnterToSubmitContextValue = {
  mode: EnterToSubmitMode;
  enabled: boolean;
};

/** Enter-to-submit settings from AppForm. Null outside AppForm. */
export const EnterToSubmitContext = createContext<EnterToSubmitContextValue | null>(null);

/** Returns enter-to-submit settings from AppForm, or null when outside AppForm. */
export function useEnterToSubmitContext(): EnterToSubmitContextValue | null {
  return useContext(EnterToSubmitContext);
}
